import React from 'react';
import { Link } from 'react-router-dom';
import { useData } from '../context/DataContext';
import { Calendar, User, ArrowRight } from 'lucide-react';

const Blog: React.FC = () => {
  const { posts, settings } = useData();

  return (
    <div className="bg-neutral-50 min-h-screen pt-24 pb-12">
      {/* Header */}
      <div className="bg-neutral-900 text-white py-16 mb-12 relative overflow-hidden">
        <div className="absolute inset-0 bg-automax-red opacity-10 transform skew-y-3 scale-110"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
          <h1 className="font-display text-5xl font-bold uppercase tracking-wider mb-4">
            News & Insights
          </h1>
          <p className="text-gray-400 max-w-2xl mx-auto text-lg">
            Stay updated with the latest trends in the transport industry, maintenance tips, and company news.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {posts.length === 0 ? (
          <div className="text-center py-20">
            <h3 className="text-2xl font-bold text-gray-400">No articles found. Check back soon!</h3>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {posts.map((post) => (
              <article
                key={post.id}
                className="bg-white rounded-sm shadow-md overflow-hidden hover:shadow-xl transition-shadow duration-300 flex flex-col h-full"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                  />
                  <div className="absolute top-4 left-4">
                    <span
                      style={{ backgroundColor: settings.logoColor }}
                      className="text-white text-xs font-bold uppercase px-3 py-1 rounded-sm"
                    >
                      {post.category}
                    </span>
                  </div>
                </div>

                <div className="p-6 flex flex-col flex-grow">
                  <div className="flex items-center text-xs text-gray-500 mb-3 space-x-4">
                    <div className="flex items-center">
                      <Calendar size={14} className="mr-1" />
                      {new Date(post.date).toLocaleDateString()}
                    </div>
                    <div className="flex items-center">
                      <User size={14} className="mr-1" />
                      {post.author}
                    </div>
                  </div>

                  <h2 className="font-display text-2xl font-bold text-gray-900 mb-3 line-clamp-2 hover:text-automax-red transition-colors">
                    <Link to={`/blog/${post.id}`}>{post.title}</Link>
                  </h2>

                  <p className="text-gray-600 text-sm mb-4 line-clamp-3 flex-grow">
                    {post.excerpt}
                  </p>

                  <Link
                    to={`/blog/${post.id}`}
                    style={{ color: settings.logoColor }}
                    className="inline-flex items-center font-bold text-sm uppercase tracking-wider hover:underline mt-auto"
                  >
                    Read More <ArrowRight size={16} className="ml-1" />
                  </Link>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Blog;
